import { render, staticRenderFns } from "./keyword.vue?vue&type=template&id=85c9fe10&scoped=true&"
import script from "./keyword.vue?vue&type=script&lang=js&"
export * from "./keyword.vue?vue&type=script&lang=js&"
import style0 from "./keyword.vue?vue&type=style&index=0&id=85c9fe10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c9fe10",
  null
  
)

export default component.exports